// Function to update max-width

function updateMaxWidth($formEmbed) {
  // Select the section node

    var formWrapper = $formEmbed[0].shadowRoot.childNodes[0].querySelector(
    "[data-testid='form-container']"
  );
  if (formWrapper) {
    // Update the max-width
    $(formWrapper).css("max-width", "800px");
    $(formWrapper).find("p, h2, h3, label, button, input").css({
      "font-family": "Outfit",
    });
    $(formWrapper).find('h2').css("font-family", "600");

    /* Add autocomplete to address field*/
    var input = formWrapper.querySelector(
      "[data-testid='field-custom#address']"
    );

    const options = {
      componentRestrictions: { country: "au" },
      fields: ["formatted_address", "address_components", "geometry", "icon", "name"]
    };
    const autocomplete = new google.maps.places.Autocomplete(input, options);
    autocomplete.addListener('place_changed', function() {
      var place = autocomplete.getPlace();
      if (!place.geometry) {
          console.log("Returned place contains no geometry");
          return;
      }
  
      // Update the input field with the formatted address
      input.value = place.formatted_address;
      console.log(input.value);
    });
  }  
  
}

// Select the target node
var targetNode = document.body; // You can change this to a more specific parent node if needed

// Options for the observer (specify which mutations to observe)
var config = { childList: true, subtree: true };
const observer = new MutationObserver(function (mutationsList) {
  for (const mutation of mutationsList) {
    for (const node of mutation.addedNodes) {
      if (node.nodeType === 1) { // Element node
        if (node.matches && node.matches('form-embed')) {
          // Directly added form-embed
          updateMaxWidth($(node));
        } else if (node.querySelectorAll) {
          // Check if form-embed exists inside this node
          const embeds = node.querySelectorAll('form-embed');
          embeds.forEach(embed => updateMaxWidth($(embed)));
        }
      }
    }
    if(mutation.addedNodes.length==2){
      observer.disconnect();
    }
  }
});

// Start observing the target node for configured mutations
observer.observe(targetNode, config);
